import { render, staticRenderFns } from "./SocialGrid.vue?vue&type=template&id=002f04e8&scoped=true"
import script from "./SocialGrid.vue?vue&type=script&lang=js"
export * from "./SocialGrid.vue?vue&type=script&lang=js"
import style0 from "./SocialGrid.vue?vue&type=style&index=0&id=002f04e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f04e8",
  null
  
)

export default component.exports